<template>
    <div>
        <Row :gutter="10" style="margin-bottom: 8px">
            <Col>
                <DatePicker type="daterange" v-model="filter_pickUpDate" placeholder="Pickup Date"
                            :clearable="false" format="dd/MM/yyyy" style="width: 264px" @on-change="onChangeDate"></DatePicker>
            </Col>

            <Col span="5" offset="7" style="margin-top: -31px;">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: dealerCityFilter}"
                             :debounce="500" :skip="skip.dealerSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Order City" v-model="dealerCity" :clearable="true"
                                          @on-clear="onClearCity('clientCity')" @on-search="onSearchCity($event, 'clientCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'clientCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col span="5" style="margin-top: -31px;">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: pickupCityFilter}"
                             :debounce="500" :skip="skip.pickupSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Pickup City" v-model="pickupCity" :clearable="true"
                                          @on-clear="onClearCity('pickupCity')" @on-search="onSearchCity($event, 'pickupCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'pickupCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col span="5" style="margin-top: -31px;">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: droppingCityFilter}"
                             :debounce="500" :skip="skip.dropSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Drop City" v-model="droppingCity" :clearable="true"
                                          @on-clear="onClearCity('dropCity')" @on-search="onSearchCity($event, 'dropCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'dropCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
        </Row>


          <hot-table :settings="hotSettings" ref="hotTableComponent" style="margin: 20px 0 0 0">
            <hot-column v-for="(colset, index) in columns" :settings="colset" :key="index"/>
          </hot-table>

      <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"/>
    </div>
</template>

<script>
import { HotTable, HotColumn } from '@handsontable/vue'
import { SEARCH_CITY2 } from '../graphql/queries/territories'
import {SUBSCRIBE_COMPLETED_ORDERS} from '../graphql/subscription/Orders'
import moment from 'moment'
import {carryBillRenderer, ewayBillRenderer, localVehicleRenderer,
  orderDetailsRenderer, orderNumberRenderer, statusRenderer, transportVehicleRenderer
} from "./ExcelFormattedOrders/RendererFunctions";
import {generateHotSettings, roughtOfOrder} from "./ExcelFormattedOrders/Settings";
import ManageOrder from "./Manage Order/ManageOrder";

  export default {
    name: 'CompletedOrders',
    props:['globalSearch'],
    components: {HotTable, HotColumn, ManageOrder },
    provide() {
      return {
        getManageOrderDrawer: () => this.manageOrderDrawer,
        setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
        getOrder: () => this.order,
        closeAssignVehicleDialog: (data) => { },
      }
    },
    apollo: {
      $subscribe: {
        orders: {
          query: SUBSCRIBE_COMPLETED_ORDERS,
          variables() {
            return {
              startDate: this.startDate, endDate: this.endDate,
              clientCity: this.selectedDealerCity,
              pickupCity: this.selectedPickupCity,
              dropCity: this.selectedDroppingCity,
              searchFilter: '%' + this.globalSearch + '%',
              lrName: {lrName: this.globalSearch},
            }
          },
          result({data}) {
              this.orders = data.orders;
              this.prepareSheetData(data.orders)
          }
        }
      }
    },
    data() {
        return {
            query_SEARCH_CITY: SEARCH_CITY2,
            orders: [],
            columns: [
              //table_key_intermediate
              {
                title: 'Created On',
                data: 'createdAt',
                type: 'date',
                dateFormat: 'DD MMM \'YY hh:mm A'
              },
              {
                title: 'Updated On',
                data: 'updatedAt',
                type: 'date',
                dateFormat: 'DD MMM \'YY hh:mm A'
              },
              {
                title: 'Pickup<br> Date',
                data: 'orders_pickupDate',
                type: 'date',
                dateFormat: 'DD/MM/YYYY',
              },
              {
                title: 'ERP Order<br>No',
                data: 'orderNumber',
                renderer: (...args) => orderNumberRenderer(...args, this, 'orders')
              },
              {
                title: 'Route',
                data: 'rought'
              },
              {
                title:'Status',
                data: 'internalStatusId',
                renderer: statusRenderer,
                exportKey: 'internalStatus'
              },
              {
                title:'Comment',
                data: 'comment'
              },
              {
                title:'Client Name',
                data: 'clientName',
              },
              {
                title:'Pickup Point',
                data: 'pickupPartyName'
              },
              {
                title:'Drop Point',
                data: 'dropPartyName'
              },
              {
                title:'Company',
                data: 'companyName',
              },
              {
                title:'Total<br> Weight',
                data: 'kg',
                type:'numeric'
              },
              {
                title:'Order<br> Details',
                data: 'boxes',
                renderer: (...args) => orderDetailsRenderer(...args, this, 'orders')
              },
              {
                title:'Order Note',
                data: 'orders_note'
              },
              {
                title:'LR No.',
                data: 'orderDetails_lrName_lrObject',

              },
              {
                title:'Local<br>Transport',
                data: 'tempoPlateNum',
                renderer: (...args) => localVehicleRenderer(...args, this, 'orders')
              },
              {
                title:'Truck<br> Details',
                data: 'truckPlateNumber',
                renderer: (...args) => transportVehicleRenderer(...args, this, 'orders')
              },
              {
                title:'Eway Bill No',
                data: 'orderDetails_ewayBillNo',
                renderer: (...args) => ewayBillRenderer(...args, this, 'orders')
              },
              {
                title:'Bills',
                data: 'carryBill',
                renderer: carryBillRenderer,
              }
            ],
            hotSettings: generateHotSettings([120, 120, 90, 110, 100, 145, 145, 120, 120, 110, 110, 85, 120, 145, 85, 115, 115, 125, 75]),
            filter_pickUpDate: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
            startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            dealerCity: '',
            pickupCity: '',
            droppingCity: '',
            skip: {dealerSkip: true, pickupSkip: true, dropSkip: true}, //To Avoid calls at initial
            dealerCityFilter: '%%',
            pickupCityFilter: '%%',
            droppingCityFilter: '%%',
            selectedDealerCity: {"address":[]},
            selectedPickupCity: {"address":[]},
            selectedDroppingCity: {"address":[]},
            manageOrderDrawer: false,
            orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
            currentOrderStatus: '',
            order: '',
            viewPath: '',
        }
    },
    computed: {},
    methods: {
        onChangeDate(evt){
            this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
            this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
        },
        onSearchCity(event, str){
            if(str === 'clientCity'){
                this.dealerCityFilter = '%' + this.dealerCity + '%';
                this.skip.dealerSkip = false;
            }else if(str === 'pickupCity'){
                this.pickupCityFilter = '%' + this.pickupCity + '%';
                this.skip.pickupSkip = false;
            }else if(str === 'dropCity'){
                this.droppingCityFilter = '%' + this.droppingCity + '%';
                this.skip.dropSkip = false;
            }
        },
        onSelectCity(city, str){
            if(str === 'clientCity'){
                this.selectedDealerCity = {"address":[{"city": city}]};
            }else if(str === 'pickupCity'){
                this.selectedPickupCity = {"address":[{"city": city}]};
            }else if(str === 'dropCity'){
                this.selectedDroppingCity = {"address":[{"city": city}]};
            }
        },
        onClearCity(str){
            if(str === 'clientCity'){
                this.selectedDealerCity = {"address":[]};
            }else if(str === 'pickupCity'){
                this.selectedPickupCity = {"address":[]};
            }else if(str === 'dropCity'){
                this.selectedDroppingCity = {"address":[]};
            }
        },
        prepareSheetData(data){
          let mainArr = [], totalWeight = 0;
          data.forEach(curnt => {
            curnt.obj = {
              createdAt: moment(curnt.createdAt).format('DD MMM \'YY hh:mm A'),
              updatedAt: moment(curnt.updated_at).format('DD MMM \'YY hh:mm A'),
              orders_pickupDate: moment(curnt.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
              orderNumber: curnt.orderNumber,
              rought: roughtOfOrder(curnt),
              internalStatusId: curnt.internalstatus,
              internalStatus: curnt.internalStatus.name,
              comment: curnt.notes.length?curnt.notes[0].note:'',
              clientName: curnt.clientobject.name,
              pickupPartyName: curnt.orderDetails&&curnt.orderDetails.pickupPoint&&curnt.orderDetails.pickupPoint.pickupPartyId?
                curnt.orderDetails.pickupPoint.pickupPartyName:curnt.pickuppartyobject.name,
              dropPartyName: curnt.orderDetails&&curnt.orderDetails.dropPoint&&curnt.orderDetails.dropPoint.dropPartyId?
                curnt.orderDetails.dropPoint.dropPartyName:curnt.droppingpartyobject.name,
              companyName: curnt.pickuppartyobject.name,
              kg: curnt.materials.kg,
              boxes: curnt.materials.boxes,
              orders_note: curnt.note?curnt.note:'-',
              orderDetails_lrName_lrObject: curnt.orderDetails&&curnt.orderDetails.lrObject?curnt.orderDetails.lrObject.lrName:'',
              tempoPlateNum: curnt.orderDetails&&curnt.orderDetails.PIckupTempo?curnt.orderDetails.PIckupTempo.tempo.platNo:
                (curnt.orderDetails&&curnt.orderDetails.PickupTruck?curnt.orderDetails.PickupTruck.truck.platNo:''),
              truckPlateNumber: curnt.orderDetails&&curnt.orderDetails.truckOrder?curnt.orderDetails.truckOrder.truck.platNo:'',
              orderDetails_ewayBillNo: curnt.orderDetails&&curnt.orderDetails.ewayBillNo?curnt.orderDetails.ewayBillNo:'-',
              priority: curnt.priority,
              carryBill: curnt.orderDetails?.carryBill,
              lastStageUpdatedOn: curnt.lastStageUpdatedOn
            }
            mainArr.push(curnt.obj)
            // totalWeight = totalWeight + Number(curnt.materials.kg)
          })
          this.hotSettings.data = mainArr
          // let hotSettingsVariable = screen + '_hotSettings'
          // this[hotSettingsVariable].data = mainArr
          // this.updateTableSettings(screen)
          // this.prepareComments(screen)
          // this.totalWeight[screen] = totalWeight
       /* let hotInstance = this.$refs['hotTableComponent'].hotInstance
          hotInstance.updateSettings({
            cells: function (row, col, prop) {
              let cellProperties = {};
              if(row === 1) cellProperties.className = 'red-row htCenter htMiddle'
              return cellProperties;
            }
          }) */
        },
        editOrder(order){
          this.orderId = order.id;
          this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
          this.order = order;
          this.currentOrderStatus = order.internalStatus.id;
          this.manageOrderDrawer = true;
        },
    }
}
</script>

<style scoped>
  /deep/ .ivu-dropdown-item{
    padding: 0px 0px;
  }
  /deep/ .ivu-dropdown-item-div{
    padding: 7px 16px;
    width: 100%;
  }
  /deep/ .ivu-date-picker-cells  {
    font-size: 12px !important;
  }
  /deep/  .ivu-spin-fix {
    top: 43px;
    left: 16px;
    z-index: 8;
    width: 86vw;
    height: 40vh;
  }
  /deep/ .handsontable > .ht_master{
    font-size: 14px;
  }
  /deep/ .handsontable > .ht_master > .wtHolder{
    width: unset !important;
    height: unset !important;
  }
  .filterInput{
    width: 80%;
  }

  /deep/ .ivu-picker-panel-sidebar  {
    width:125px !important;
    margin-left:-116px !important;
  }
  /deep/ .handsontable span.colHeader {
    font-size: 13px;
  }
  /deep/.handsontable td{
    vertical-align: middle !important;
    padding: 0 1px 0 1px !important;
    white-space: unset !important;
    font-size: 13px;
  }

  /deep/.handsontable th{
    background-color: #d9d9d9;
    color: #222;
    text-align: center;
    font-weight: 600;
    vertical-align: middle !important;
    white-space: nowrap !important;
    padding: 0 0px 0 0px !important;
  }
</style>
<style>
  .order-num-txt:hover {
    text-decoration: underline;
  }
  .green-text{
    color: green !important;
  }
  .red-text{
    color: red !important;
  }
  .red-bold-text{
    color: red !important;
    font-weight: 600;
    letter-spacing: 0.8px;
  }
  /*.red-row{
    background: red !important;
    color: white !important;
  }*/
</style>
<style src="../../node_modules/handsontable/dist/handsontable.full.css"></style>

